module.exports = __webpack_public_path__ + "img/vertical.d203dbfc.png";